import {useState} from "react";
import {Button, Modal} from "react-bootstrap";
import {Form as FormikForm, FormField, SubmitButton} from "../../../../components/forms"
import {useParams} from "react-router-dom";
import offersApi from "../../../../api/offertes";
import notyf from "../../../../utils/notyfApi";
import * as Yup from "yup";

function OfferProjectFormsModal({name, reference, reload}) {
    const {id} = useParams();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const handleSubmit = async (sid, data) => {
        const response = await offersApi.createNewService({
            service_project_id: parseInt(sid),
            ...data
        });
        if (!response.ok) return notyf.error("Error " + response.status)
        reload()
        handleClose()
    };
    return (
        <>
            <Button variant="primary" className={"float-end"} onClick={handleShow}>
                +
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title> Nieuwe onderhoudsofferte aanmaken
                    </Modal.Title>
                </Modal.Header>
                <FormikForm
                    initialValues={{
                        service_form_project_name: name || "",
                        service_form_project_reference: reference || "",
                    }}

                    Hier is het validatieschema van alle velden
                    validationSchema={Yup.object({
                        service_form_project_name: Yup.string()
                            .max(250, 'Moet minder dan 250 karakters zijn')
                            .required('Project formulier naam moet ingevuld worden'),
                        service_form_project_reference: Yup.string()
                            .max(250, 'Moet minder dan 250 karakters zijn')
                            .required('Project formulier code moet ingevuld worden'),
                    })}

                    onSubmit={(values, {setSubmitting}) => {
                        setSubmitting(false);
                        handleSubmit(id, values);
                    }}
                >
                    <Modal.Body>
                        <FormField name={"service_form_project_name"}
                                   label={"Offertenaam:"}
                                   width={"100%"}
                                   placeholder="Vul de offertenaam hier in"
                                   className={"mb-3"}
                                   control={"input"}
                        />
                        <FormField name={"service_form_project_reference"}
                                   label={"Offertereferentie"}
                                   width={"100%"}
                                   placeholder={"Vul de offertereferentie hier in"}
                                   rows={3}
                                   className={"mb-3"}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Annuleren
                        </Button>
                        <SubmitButton title={"Opslaan"} variant="primary"/>
                    </Modal.Footer>
                </FormikForm>
            </Modal>
        </>
    );
}

export default OfferProjectFormsModal;
